import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export function useAlarmTypesByName(searchParams?: string) {
  const httpClient = useHttpClient();

  return (name: string, tenantId: string) => {
    const url = `/v2/orm/alarm_type/names?name=${name}&tenant_id=${tenantId}${
      searchParams ? `&${searchParams}` : ''
    }`;

    return httpClient<Selectable[]>(url, {
      responseModifier: async (res) => {
        const respJson = await res.json();
        return respJson.payload;
      },
    });
  };
}

export default useAlarmTypesByName;
